module.exports = __webpack_public_path__ + "img/header.6d9fe497.jpg";